import classNames from "classnames";
import { useForm } from "../../hooks/useForm";
import { Alert, Check, Email, Name, Role } from "../../icons";
import type { AcceptResponse } from "../../types";
import { isEmailValid } from "../../utils";
import { Tooltip } from "./Tooltip";

declare global {
  interface Window {
    sessionStartTimestamp: "string";
    primaryVersionId: "string";
    analyticsData: {
      [key: string]: string;
    };
  }
}

export const Form = ({
  setResult,
}: {
  setResult: (result: AcceptResponse[]) => void;
}) => {
  const { formData, touched, status, setInputData, handleSubmit } = useForm({
    setResult,
  });

  return (
    <form className="popup__form" autoComplete="off">
      <div className="popup__signature">{formData.name}</div>
      <div
        className={classNames({
          popup__input: true,
          error: touched && !formData.name,
        })}
      >
        <div className="popup__input-container">
          <Name />
          <input
            type="text"
            name="name"
            required
            placeholder="Full name"
            onChange={setInputData}
          />
        </div>
        <div className="popup__input-error">
          <Alert />
          Add your name
        </div>
      </div>
      <div
        className={classNames({
          popup__input: true,
          error: touched && !isEmailValid(formData.email),
        })}
      >
        <div className="popup__input-container">
          <Email />
          <input
            type="email"
            name="email"
            required
            placeholder="Email address"
            onChange={setInputData}
          />
        </div>
        <div className="popup__input-error">
          <Alert />
          Add valid email address
        </div>
      </div>
      <div className="popup__input">
        <div className="popup__input-container">
          <Role />
          <input
            type="text"
            name="role"
            placeholder="Role (optional)"
            onChange={setInputData}
          />
        </div>
      </div>

      <Tooltip>
        <button
          type="submit"
          onClick={handleSubmit}
          className={classNames(status)}
        >
          <Check />
          Accept
          {status === "loading" ? <span className="spinner"></span> : null}
        </button>
      </Tooltip>
      <p className="popup__policy">
        By clicking 'Accept' I confirm I have the authority to approve this
        offer.
      </p>
    </form>
  );
};
